var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { IconWrapper } from ".";
export const OrderIcon = React.forwardRef((_a, ref) => {
    var { color = "primary" } = _a, otherProps = __rest(_a, ["color"]);
    return (React.createElement(IconWrapper, Object.assign({ ref: ref, width: 24, height: 24, color: color }, otherProps),
        React.createElement("path", { d: "M8.00002 5C7.44773 5 7.00002 5.44772 7.00002 6H17C17 5.44772 16.5523 5 16 5H8.00002Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.92899 7.9233C5.96907 7.40231 6.40351 7 6.92605 7H17.074C17.5965 7 18.031 7.40231 18.071 7.9233L18.9172 18.9233C18.9619 19.5041 18.5026 20 17.9201 20H6.07989C5.49738 20 5.03816 19.5041 5.08284 18.9233L5.92899 7.9233ZM9.50002 9.5C9.77616 9.5 10 9.72386 10 10V10.5C10 11.6046 10.8954 12.5 12 12.5C13.1046 12.5 14 11.6046 14 10.5V10C14 9.72386 14.2239 9.5 14.5 9.5C14.7762 9.5 15 9.72386 15 10V10.5C15 12.1569 13.6569 13.5 12 13.5C10.3432 13.5 9.00002 12.1569 9.00002 10.5V10C9.00002 9.72386 9.22387 9.5 9.50002 9.5Z" })));
});
//# sourceMappingURL=Order.js.map